export const TypeEnrollment = [{
    id: 1,
    type: "Ratification",
    value: "R"
},{
    id: 2,
    type: "Estudiantes Nuevos",
    value: "O"
},{
    id: 3,
    type: "Estudiantes Antiguos",
    value: "N"
}]